var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(-1102 -212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(398 -4772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email_message",
    "data-name": "email message",
    transform: "translate(516 4328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(188 656)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(0 0)",
    fill: "rgba(139,141,143,0.9)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M187,396h2.49",
    transform: "translate(921.755 -172.711)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M196,220h1.155v3.1",
    transform: "translate(912.918 -0.887)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M225,98a1,1,0,1,1,1-1A1,1,0,0,1,225,98Z",
    transform: "translate(885.229 119.683)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterInfoIcon);
export default __webpack_public_path__ + "static/media/toaster-info-icon.4c3a07d79ecfe9ea850c87ab78ac79c7.svg";
export { ForwardRef as ReactComponent };